module.exports = "<!-- TODO: i18next all views and any JS file -->\n<p><%= keywordErrorLabel %></p>\n<p><%= suggestionLabel %>:</p>\n<ul>\n  <% suggestionList.forEach(function(suggestion) { %>\n  <li><%= suggestion %></li>\n  <% }); %>\n</ul>\n"


//////////////////
// WEBPACK FOOTER
// ./node_modules/cigna_csg_gsg_elasticsearch/src/js/views/no-results.tpl.html
// module id = JEre
// module chunks = 4